module.exports = __webpack_public_path__ + "static/img/payment-code.3e323ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-code.png
// module id = bXGH
// module chunks = 0